import React from "react";
import { AdminNameCell, AdminRowActions } from "../admin/AdminRowCells";
import SubTabsSelect from "../restaurant/ui/SubTabsSelect";
import { formatMobileDisplayOrFallback } from "../restaurant/formatDisplay";

export const ORDER_TABS = [
  { id: "restaurantOrders", label: "Orders" },
  { id: "pickupOrders", label: "Pickups" },
];

/** Orders / Pickups switcher: button strip on tablet+desktop, dropdown on phones. */
export function OrdersTabs({ activeTab, onChange, children }) {
  return (
    <div className="org-orders-toolbar">
      <SubTabsSelect tabs={ORDER_TABS} value={activeTab} onChange={onChange} ariaLabel="Order type" />
      <div className="org-orders-tabs rt-subtabs-strip">
        {ORDER_TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {children}
    </div>
  );
}

const rowStatus = (row) => row.status || row.orderStatus || row.pickupStatus || "";

export function OrdersTable({ rows, idKey }) {
  return (
    <table className="admin-rows-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Child Details</th>
          <th>Delivery Contact</th>
          <th>Restaurant Name</th>
          <th>Food Items</th>
          <th>Food Quantity</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => {
          const name = row.childName || "N/A";
          return (
            <tr key={row[idKey] ?? index}>
              <td>
                <AdminNameCell name={name} id={row.orderId ?? row[idKey]} status={rowStatus(row)} />
              </td>
              <td>{row.childDetails || "N/A"}</td>
              <td>
                <span className="org-orders-contact">
                  <span>{row.deliveryContactName || "N/A"}</span>
                  <span className="org-orders-contact__phone">
                    {formatMobileDisplayOrFallback(row.deliveryContactNo, "")}
                  </span>
                </span>
              </td>
              <td>{row.restaurantName || "N/A"}</td>
              <td>{(row.foodItems || []).join(", ") || "N/A"}</td>
              <td>{row.foodQuantity || 0}</td>
              <td>
                <AdminRowActions name={row.deliveryContactName || name} phone={row.deliveryContactNo} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
